const Header = () => {
    return (
        <div class="generator">
            Meme-Generator
        </div>
    )
}

export default Header
